import { trackEvent } from './analytics';
import { apiClient } from './apiClient';
import { config } from '../config/env';

const CRYPTOCOMPARE_API_BASE = 'https://min-api.cryptocompare.com/data';
const API_KEY = config.cryptoCompareApiKey;

interface CryptoMarketData {
  price: number;
  marketCap: number;
  priceChange24h: number;
  dominance: number;
}

interface CryptoCompareResponse {
  RAW: {
    BTC: {
      USD: {
        PRICE: number;
        MKTCAP: number;
        CHANGEPCT24HOUR: number;
        TOTALTOPTIERVOLUME24HTO: number;
      }
    }
  }
}

const CACHE_DURATION = 30000; // 30 seconds
let cachedData: CryptoMarketData | null = null;
let lastFetchTime = 0;

export async function fetchCryptoMarketData(): Promise<CryptoMarketData> {
  const now = Date.now();
  
  if (cachedData && (now - lastFetchTime) < CACHE_DURATION) {
    return cachedData;
  }

  try {
    const response = await apiClient.get<CryptoCompareResponse>(
      `${CRYPTOCOMPARE_API_BASE}/pricemultifull?fsyms=BTC&tsyms=USD&api_key=${API_KEY}`
    );

    const btcData = response.RAW.BTC.USD;

    cachedData = {
      price: btcData.PRICE,
      marketCap: btcData.MKTCAP / 1e12, // Convert to trillions
      priceChange24h: btcData.CHANGEPCT24HOUR,
      dominance: 50.23 // This is a static value since CryptoCompare doesn't provide dominance
    };
    
    lastFetchTime = now;
    trackEvent('Crypto', 'FetchMarketData', 'Success');
    return cachedData;
  } catch (error) {
    if (cachedData) return cachedData;
    trackEvent('Crypto', 'FetchMarketData', 'Error');
    throw error;
  }
}